module.exports = __webpack_public_path__ + "img/apidays-day2-highlights.c7c473d4.jpg";